import { FC } from 'react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Link, useLocation } from '@tanstack/react-router'
import { ParseKeys } from 'i18next'

import { IconName } from '@forto-dev/phoenix-ui-core/common'
import { Navigation as NavigationComponent, NavigationItem, NavigationList } from '@forto-dev/phoenix-ui-core/ship'

const NAVIGATION_ITEMS: {
  id: string
  url: string
  icon: IconName
  search?: Record<string, unknown>
  translation: ParseKeys
}[] = [
  {
    id: 'overview',
    url: '/',
    icon: 'TransportPlan',
    translation: 'navigation.overview',
  },
  {
    id: 'quotes',
    url: '/quotes',
    icon: 'Document',
    translation: 'navigation.quotes',
  },
  {
    id: 'reports',
    url: '/reports',
    icon: 'BarChart',
    translation: 'navigation.reports',
  },
  {
    id: 'billing',
    url: '/billing',
    icon: 'Bill',
    translation: 'navigation.billing',
  },
]

export const Navigation: FC = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const currentBasePath = useMemo(
    () =>
      location.pathname
        .replace(new RegExp(`^${window.config?.APP_BASE_URL}`), '/')
        .replace(/^\/{2,}/, '/')
        .split('/')
        .slice(0, 2)
        .join('/'),
    [location.pathname]
  )

  return (
    <NavigationComponent>
      <NavigationList>
        {NAVIGATION_ITEMS.map(({ id, url, icon, translation, search }) => (
          <Link to={url} key={id} search={search}>
            <NavigationItem active={currentBasePath === url} icon={icon}>
              {t(translation)}
            </NavigationItem>
          </Link>
        ))}
      </NavigationList>
    </NavigationComponent>
  )
}
